import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format, startOfMonth, set, isValid } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SelectTable from '../../components/DataTable/SelectTable';
import { fetchEmployees } from '../../store/actions/employee';
import { requestTimeClockReport, newRequestTimeClockReport, requestListReport } from '../../store/actions/report';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';
import { fileDownload } from '../../shared/fileDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import axiosInstance from '../../config/axiosInstance';


const styles = theme => ({
    container: {
        padding: `0 ${theme.spacing(3)}px`,
    },
});

class TimeClockReport extends React.Component {
    state = {
        withExtraHours: true,
        startDate: '',
        endDate: '',
        selected: [],
        searchQuery: '',
        validaetPremium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
        loading: false,
        uuid: '',
        lisEmployees: [],
        name: '',
        numSelected: null,
        companyName: ''
    };

    componentWillMount() {
        this.setState({
            startDate: startOfMonth(new Date()),
            endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
        });
        this.getListEmployees();
    }

    getListEmployees = async () => {
        const result = await axiosInstance.get('/employee/list')
        this.setState({ lisEmployees: result.data })
    }

    componentDidMount() {
        // this.props.onFetchEmployees();
    }

    handleListRequestReport = () => {
        const {
            startDate, endDate, selected, withExtraHours,
        } = this.state;
        const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);

        const report = {
            companyId: companyData.companyId,
            employeeId: selected,
            startPeriod: format(startDate, 'yyyy/MM/dd HH:mm'),
            endPeriod: format(endDate, 'yyyy/MM/dd HH:mm')
        };

        this.props.onRequestListReport(report);
    };



    observerNewHandleRequestReport = (value) => {
        if (this.state.uuid == 'impresso') {
            console.log('chama socket');
            this.setState({ loading: false })
        } else {
            this.setState({ loading: true })
            console.log('passou no else');
            setTimeout(() => this.handleRequestpdf(value), 3000)
        }
    };

    handleInputChange = name => (event) => {
        if (event && event.target) {
            const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            this.setState({ [name]: value });
        } else {
            this.setState({ [name]: event });
        }
    };

    handleSelectAll = (event, checked, searchSelect) => {
        const searchIndex = searchSelect.map(employee => employee.id);
        if (checked) {
            const newSelected = this.state.selected.slice();

            /* eslint-disable no-underscore-dangle */
            if (searchIndex) {
                if (this.state.selected.indexOf(searchIndex[0]) === -1) {
                    this.state.lisEmployees.map(employee =>
                    (searchIndex.indexOf(employee.id) > -1 &&
                        newSelected.indexOf(employee.id) === -1 &&
                        employee._workingDay !== null
                        ? newSelected.push(employee.id)
                        : null));
                } else {
                    this.state.lisEmployees.map(employee =>
                    (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
                        ? newSelected.splice(newSelected.indexOf(employee.id), 1)
                        : null));
                }
            }
            /* eslint-enable */

            this.setState({ selected: newSelected });
        } else if (searchIndex.length === this.state.lisEmployees.length) {
            this.setState({ selected: [] });
        } else {
            const newSelected = this.state.selected.slice();
            this.state.lisEmployees.map(employee =>
            (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
                ? newSelected.splice(newSelected.indexOf(employee.id), 1)
                : null));

            this.setState({ selected: newSelected });
        }
    };

    handleSelect = (event, id, name, numSelected) => {
        const { selected, lisEmployees } = this.state;
        const newSelected = [id];
        const updatedEmployees = lisEmployees.map(employee => {
            if (employee.id !== id) {
                return { ...employee, disabled: true };
            }
            return employee;
        });
        this.setState({ selected: newSelected, lisEmployees: updatedEmployees, name: name });
    };


    isSelected = id => this.state.selected.indexOf(id) !== -1;

    render() {
        const { classes, loading } = this.props;
        const {
            withExtraHours, startDate, endDate, selected, searchQuery, validaetPremium, lisEmployees
        } = this.state;

        const columns = [
            { name: 'enrollment', label: 'Matrícula' },
            { name: 'name', label: 'Nome' },
            { name: '_office', label: 'Cargo' },
            { name: 'department', label: 'Departamento' },
            { name: '_workingDay', label: 'Escala' },
        ];

        const searchFields = ['enrollment', 'name', '_office', 'department', '_workingDay'];

        return (
            <React.Fragment>
                <ContentHeader
                    title="Lista de Ponto"
                    subtitle="Selecione o período e os funcionários para gerar a sua lista de pontos"
                >
                    <Grid>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleListRequestReport}
                            disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length && selected.length <= 5)}
                        >
                            <PDFIcon /> Gerar Lista de pontos
                        </Button>
                    </Grid>
                </ContentHeader>

                <Paper elevation={2}>
                    <Grid
                        container
                        justify="space-between"
                        alignItems="baseline"
                        className={classes.container}
                    >
                        <Grid item xs={12} md={5}>
                            <TextField
                                value={searchQuery}
                                onChange={this.handleInputChange('searchQuery')}
                                label=" "
                                placeholder="Buscar"
                                type="text"
                                fullWidth
                                margin="normal"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon color="disabled" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} container justify="space-around">
                            <Input
                                elementType="dateTimePicker"
                                label="Início do período"
                                margin="normal"
                                value={startDate}
                                onChange={this.handleInputChange('startDate')}
                            />
                            <Input
                                elementType="dateTimePicker"
                                minDate={startDate}
                                label="Fim do período"
                                margin="normal"
                                value={endDate}
                                onChange={this.handleInputChange('endDate')}
                            />
                        </Grid>
                    </Grid>

                    <SelectTable
                        rows={lisEmployees}
                        columns={columns}
                        loading={loading}
                        // disableRow="_workingDay"
                        searchFields={searchFields}
                        onSelect={this.handleSelect}
                        // onSelectAll={this.handleSelectAll}
                        onSearchSelect={this.handleSearchSelect}
                        checkSelect={this.isSelected}
                        numSelected={selected.length}
                        searchQuery={searchQuery.toUpperCase()}
                        PointMirrorReport={validaetPremium ? false : true}
                        listReport={true}
                    />

                    {this.state.loading ? <Paper elevation={0} style={{ textAlign: 'center', margin: 10 }}>
                        <CircularProgress color="inherit" size={20} />
                        <Typography color="textSecondary" style={{ margin: 10 }}>
                            *Aguarde um momento, estamos trabalhando na sua lista.
                        </Typography>
                    </Paper> : ""}

                </Paper>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.general.loading,
    // employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
    // onFetchEmployees: () => dispatch(fetchEmployees()),
    onRequestListReport: report => dispatch(requestListReport(report))
});

TimeClockReport.propTypes = {
    classes: PropTypes.object.isRequired,
    onFetchEmployees: PropTypes.func.isRequired,
    onRequestReport: PropTypes.func.isRequired,
    onRequestListReport: PropTypes.func.isRequired,
    // employees: PropTypes.array.isRequired,
    loading: PropTypes.bool,
};

TimeClockReport.defaultProps = {
    loading: false,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(TimeClockReport));
